import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2"; // SweetAlert import kiya

function ForgetPass() {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const sendOtp = async (e) => {
    e.preventDefault();

    try {
      await axios.post("https://uniformnx-com.onrender.com/user/send-otp", { email });

      // Success Popup
      Swal.fire({
        icon: "success",
        title: "OTP Sent!",
        text: "OTP has been sent to your email address.",
        timer: 2000,
        showConfirmButton: false,
      });

      // Navigate to verify page with email state
      navigate("/verify-otp", { state: { email } });
    } catch (err) {
      // Error Popup
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.message || "Error sending OTP",
        confirmButtonColor: "#d33",
      });
    }
  };

  return (
    <div
      style={{
        textAlign: "center",
        padding: "50px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundImage:
          "url(https://png.pngtree.com/background/20210709/original/pngtree-cartoon-education-training-cram-school-picture-image_917042.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="col-11 col-md-5">
        <form
          onSubmit={sendOtp}
          className="form-control p-5 shadow"
          style={{
            background: "rgba(255,255,255,0.2)",
            backdropFilter: "blur(10px)",
            border: "none",
          }}
        >
          <h2 className="text-white mb-4">Forgot Password</h2>
          
          <p className="text-white-50 mb-4">
            Enter your email to receive an OTP code.
          </p>

          <input
            type="email"
            className="form-control mb-4 text-center mx-auto w-75"
            placeholder="Enter Email"
            required
            onChange={(e) => setEmail(e.target.value)}
          />

          <button 
            type="submit" 
            className="animated-btn btn border-1 w-75 border-light text-light"
          >
            <span>Send OTP</span>
          </button>

          <div className="mt-4">
            <button 
              onClick={() => navigate(-1)} 
              className="btn btn-link text-white text-decoration-none"
              style={{ fontSize: "0.9rem" }}
            >
              ← Back to Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ForgetPass;